import {ActionEvent} from "../../action.event";
import {EditMode} from "./edit-mode";

export class EditPageActionEvent extends ActionEvent {
    editMode: EditMode;
    actionComplete: Promise<Boolean>;

    constructor(editMode: EditMode, data?: any) {
        super(data);
        this.editMode = editMode;
    }
}
